import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'

import type { UserInviteCodeFormInviterState } from '@root/features/referral/atoms/reatom-use-invite-code-form'

type Props = {
  inviterStateAtom: UserInviteCodeFormInviterState
}

export const InviteCodeUserAvatar = ({ inviterStateAtom }: Props) => {
  const [inviterState] = useAtom(inviterStateAtom)

  const userShort = inviterState.value

  const referralCodeStatus = inviterState.value?.referralCodeStatus
  const isHyped = referralCodeStatus === 'Hyped'

  return (
    <HeaderAvatar>
      {userShort ? (
        <UserShortAvatar size={45} userShort={userShort} />
      ) : (
        <>
          {isHyped ? <UserShortAvatar.HypedOutline size={45} /> : undefined}
          <UserAvatarPlaceholder />
        </>
      )}
    </HeaderAvatar>
  )
}

const HeaderAvatar = styled.div`
  margin-top: 5px;
  position: relative;
`

const UserAvatarPlaceholder = styled.div`
  background: var(--backgroundA-3);

  width: 45px;
  height: 45px;
  border-radius: 50%;

  backdrop-filter: blur(2px);
`
